
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mystic",
      function () {
        return require("private-next-pages/mystic/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mystic"])
      });
    }
  